



































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import AnxAlert from "../AnxAlert/AnxAlert.vue";
import AnxButton from "../AnxButton/AnxButton.vue";
import AnxContent from "../AnxContent/AnxContent.vue";
import AnxForm from "../AnxForm/AnxForm.vue";
import AnxInput from "../AnxInput/AnxInput.vue";
import AnxParagraph from "../AnxParagraph/AnxParagraph.vue";
import AnxTextarea from "../AnxTextarea/AnxTextarea.vue";
import VueRecaptcha from "vue-recaptcha";

@Component({
  components: {
    AnxAlert,
    AnxButton,
    AnxContent,
    AnxForm,
    AnxInput,
    AnxParagraph,
    AnxTextarea,
    VueRecaptcha
  }
})
export default class AnxContact extends Vue {
  /** The key for the google recaptcha V2. Will only be rendered, if porvided */
  @Prop({ default: null }) recaptchaSitekey!: string | null;

  /** implement an invisible captcha */
  @Prop({ default: true }) invisibleCaptcha!: boolean;

  /** The title to be displayed on top */
  @Prop({ default: "Contact" }) title!: string;

  /** Property for the first name field */
  @Prop({
    default: () => {
      return {
        name: "first name",
        label: "First name"
      };
    }
  })
  firstName!: { name: string; label: string };

  /** Property for the last name field */
  @Prop({
    default: () => {
      return {
        name: "last name",
        label: "Last name"
      };
    }
  })
  lastName!: { name: string; label: string };

  /** Property for the email field */
  @Prop({
    default: () => {
      return {
        name: "email",
        label: "Email"
      };
    }
  })
  email!: { name: string; label: string };

  /** Property for the phone field */
  @Prop({
    default: () => {
      return {
        name: "phone",
        label: "Phone"
      };
    }
  })
  phone!: { name: string; label: string };

  /** Property for the message field */
  @Prop({
    default: () => {
      return {
        name: "message",
        label: "Message"
      };
    }
  })
  message!: { name: string; label: string };

  /** Property for the send button */
  @Prop({
    default: () => {
      return {
        text: "Send"
      };
    }
  })
  sendButton!: { text: string };

  /** Defines whether to contact form is enabled or not (can press send button) */
  @Prop({ default: true }) enabled!: boolean;

  /** Display a field to enter the phone */
  @Prop({ default: false }) showPhone!: boolean;

  /** Display a field to enter the email */
  @Prop({ default: true }) showEmail!: boolean;

  /** The error to display. Will automatically be displayed if it changes or the showError() method is called */
  @Prop({ default: null }) error!: string;

  /** The success message to display. Will automatically be displayed if it changes or the showSuccess() method is called */
  @Prop({ default: null }) success!: string;

  /** Display the alert if the error message has changed */
  @Watch("error")
  onErrorChanged() {
    this.showError();
  }

  /** Display the alert if the success message has changed */
  @Watch("success")
  onSuccessChanged() {
    this.showSuccess();
  }

  /** This is returned on submit via @sumbit event */
  private request: {
    firstName: string | null;
    lastName: string | null;
    email: string | null;
    phone: string | null;
    message: string | null;
    captchaToken: string | null;
  } = {
    firstName: null,
    lastName: null,
    email: null,
    phone: null,
    message: null,
    captchaToken: null
  };

  /** Show the error alert */
  private showError_ = false;

  /** Show the success alert */
  private showSuccess_ = false;

  /** Is true if the recaptcha has an error (alert will be shown) */
  private internalRecaptchaError = false;

  /** Show the error */
  public showError() {
    this.showError_ = true;
  }

  /** Show the success */
  public showSuccess() {
    this.showSuccess_ = true;
  }

  /** Checks if the recaptcha should be used */
  private get useRecaptcha() {
    return this.recaptchaSitekey === null ? false : true;
  }

  /** Returns if the button should be enabled or not */
  private get isButtonEnabled(): boolean {
    if (this.useRecaptcha) {
      // When using recaptcha, it has to be checked
      return this.request.captchaToken && this.enabled ? true : false;
    } else {
      // Otherwise only check if the form is enabled
      return this.enabled ? true : false;
    }
  }

  /** Is called if the captcha has been verified. The captcha token is passed */
  private async verifyCaptcha(res: string) {
    if (res) {
      this.request.captchaToken = res;
    }

    // If the capctha is invisible, the form should also be submitted
    if (this.invisibleCaptcha) {
      // Check if the form is valid
      const valid = await ((this.$refs
        .contactForm as unknown) as AnxForm).isValid();

      if (valid) {
        // Submit if valid
        this.submit();
      } else {
        // Reset the captcha if invalid
        ((this.$refs.invisibleCaptcha as unknown) as VueRecaptcha).reset();
      }
    }
  }

  /** Is called if the captcha has an error */
  private errorCaptcha() {
    this.request.captchaToken = null;
    this.internalRecaptchaError = true;
  }

  /** Is called if the token has expired */
  private expiredCaptcha() {
    this.request.captchaToken = null;
  }

  /** Emit the submit event and add the request data */
  private submit() {
    /**
     * triggered on contact form submit
     * @event submit
     * @property {object} request - The request containing the data the user entered
     */
    this.$emit("submit", this.request);
  }
}
